export const infocusContainer = {    
    padding: '50px 7%'
};
export const H2 = {
    textAlign: 'center',    
    color: '#003755',
    font: '500 2.25em Danske Human'
};